import { render, staticRenderFns } from "./DocumentCloudHandler.vue?vue&type=template&id=0f6fbbf3&scoped=true&"
import script from "./DocumentCloudHandler.vue?vue&type=script&lang=js&"
export * from "./DocumentCloudHandler.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCloudHandler.vue?vue&type=style&index=0&id=0f6fbbf3&prod&scoped=true&lang=css&"
import style1 from "./DocumentCloudHandler.vue?vue&type=style&index=1&id=0f6fbbf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6fbbf3",
  null
  
)

export default component.exports